var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"filter"},_vm._l((_vm.filters),function(filter){return _c('li',{key:filter.value},[_c('span',{class:_vm.selectedFilter === filter.value ? 'active' : '',attrs:{"data-cy":"page-filter"},on:{"click":() => _vm.onClick(filter.value)}},[_vm._v(_vm._s(filter.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }